import { ImageBlockProps } from './type';

interface Props {
  blockProps: ImageBlockProps;
  scaleFactor?: number;
}

export const ImageBlock: React.FC<Props> = (props) => {
  const { blockProps, scaleFactor = 1 } = props;
  const { url, label, height, isUpload, width } = blockProps;
  const imageUrl = isUpload ? url : `${url}`;

  return (
    <>
      {isUpload ? (
        <div
          style={{
            width: `${width * scaleFactor}px`,
            height: `${height * scaleFactor}px`,
          }}
        >
          <img
            src={imageUrl}
            alt={label}
            style={{
              width: width * scaleFactor,
              height: height * scaleFactor,
              objectFit: 'contain',
            }}
          />
        </div>
      ) : (
        <div
          style={{
            width: `${width * scaleFactor}px`,
            height: `${height * scaleFactor}px`,
          }}
        >
          {url ? (
            <img
              src={imageUrl}
              alt={label}
              style={{
                width: width * scaleFactor,
                height: height * scaleFactor,
                objectFit: 'contain',
              }}
            />
          ) : (
            <div
              className="h-full w-full outline-dashed outline-1 flex items-center justify-center"
              style={{ fontSize: height * 0.25 * scaleFactor }}
            >
              {label}
            </div>
          )}
        </div>
      )}
    </>
  );
};
